import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';

export const getThemes = createAsyncThunk('themes/getThemes', async () => {
    const { data } = await http.get(`api/v1/themes`);
    return data.data;
});

export const createTheme = createAsyncThunk(
    'themes/createTheme',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/theme', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const editTheme = createAsyncThunk(
    'themes/editTheme',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/theme/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteTheme = createAsyncThunk(
    'themes/deleteTheme',
    async (id) => {
        await http.delete(`api/v1/theme/${id}`);
    },
);

const initialState = {
    themesLoadingStatus: 'idle',
    themes: [],
    errors: {},
};

export const themesSlice = createSlice({
    name: 'themes',
    initialState,
    reducers: {},
    extraReducers: {
        [getThemes.pending]: (state, action) => {
            state.themesLoadingStatus = 'loading';
        },
        [getThemes.fulfilled]: (state, action) => {
            state.themesLoadingStatus = 'succeeded';
            state.themes = action.payload;
        },
        [getThemes.rejected]: (state, action) => {
            state.themesLoadingStatus = 'failed';
        },
    },
});

/* Selectors */
export const allThemes = (state) => state.themes.themes;
export const themesLoadingStatus = (state) => state.themes.themesLoadingStatus;

export default themesSlice.reducer;
